import React from 'react';
import './KpiCard.scss';

const hexToRgba = (hex, alpha) => {
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!match) return null;
  const [, r, g, b] = match;
  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${alpha})`;
};

const KpiCard = ({ title, value, icon = null, className = '', iconColor }) => {
  const classes = ['kpi-card', className].filter(Boolean).join(' ');

  const resolvedIconColor = iconColor || '#111827';
  const resolvedIconBg =
    (iconColor && hexToRgba(iconColor, 0.2)) || 'rgba(0, 0, 0, 0.06)';

  return (
    <div className={classes}>
      <div className="kpi-header">
        <div className="kpi-title">{title}</div>
        {icon && (
          <div
            className="kpi-icon"
            style={{ color: resolvedIconColor, backgroundColor: resolvedIconBg }}
          >
            {icon}
          </div>
        )}
      </div>
      <div className="kpi-value-container">
        <span className="kpi-value">{value}</span>
      </div>
    </div>
  );
};

export default KpiCard;

